import { Suspense, lazy } from 'react';

import { Box, CircularProgress } from '@mui/material';

import { chunkMapping } from '@/chunks/chunkMapping';

const withDynamicImport = <K extends string>(componentName: K) => {
  const DynamicComponent = lazy(chunkMapping[componentName]);

  return (props: React.ComponentProps<typeof DynamicComponent>) => (
    <Suspense
      fallback={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <DynamicComponent {...props} />
    </Suspense>
  );
};

export default withDynamicImport;
